module.exports = __webpack_public_path__ + "img/empty_state_candidates.9ba14ad3.svg";